"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDotenvWebpackVar = exports.setGlobalVar = exports.getGlobalVar = void 0;
const constants_iso_1 = require("@wranggle/constants-iso");
// accessing window can confuse tests running outside of a browser, depending on if/when jsdom or similar is loaded so:
if (typeof window === 'undefined') {
    global['window'] = global;
}
window[constants_iso_1.GlobalContextName] = window[constants_iso_1.GlobalContextName] || {};
function getGlobalVar(attribName) {
    return window[constants_iso_1.GlobalContextName][attribName];
}
exports.getGlobalVar = getGlobalVar;
function setGlobalVar(attribName, val) {
    window[constants_iso_1.GlobalContextName][attribName] = val;
}
exports.setGlobalVar = setGlobalVar;
/**
 * Get value of build-time env var name, as set by dotenv-webpack if that's being used.
 * @param name
 */
function getDotenvWebpackVar(name) {
    if (window['process'] && window['process']['env']) {
        return window['process']['env'][name];
    }
}
exports.getDotenvWebpackVar = getDotenvWebpackVar;
//# sourceMappingURL=global-vars.js.map